export default {
  title: '推荐排行榜',
  menu: '排行榜',
  status: {
    shares: '已分享的职位',
    submits: '已提交简历',
    views: '已查看',
    applied: '已申请',
    interviewed: '已面试',
    onboard: '已入职',
    probation: '已转正',
    all: '奖励'
  }
}
